import axios from "axios";
import qs from "qs";

export class ManagementApi {
  async getFilterManagementView(params: any = {}, signal?: AbortSignal) {
    let path = `/api/ManagementView/GetListCustomerManagementFilter?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path, { signal });
        return response.data;
      }
    } catch (error) {
      if (axios.isCancel(error)) throw error;
      throw error;
    }
  }

  async getCustomerManagementView(params: any = {}, signal?: AbortSignal) {
    let path = '';
    if(params.searchText){
      path = `/api/ManagementView/SearchCustomerEvent?${qs.stringify(params)}`
    }else{
      path = `/api/ManagementView/ListOfCustomerEvent?${qs.stringify(params)}`;
    }
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path, { signal });
        return response.data;
      }
    } catch (error) {
      if (axios.isCancel(error)) throw error;
      console.error(`Error fetch overview`, error);
      throw error;
    }
  }

  async getCustomerCredit(params: any = {}) {
    let path = `/api/ManagementView/GetCustomerCredit?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch customer credit`, error);
      throw error;
    }
  }

  async getActivityHistory(params: any = {}) {
    let path = `/api/ManagementView/GetHistoryActivity?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch overview`, error);
      throw error;
    }
  }

  async getActivityNext(params: any = {}) {
    let path = `/api/ManagementView/GetNextActivity?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch overview`, error);
      throw error;
    }
  }

  async getEActivity(params: any = {}) {
    let path = `/api/ManagementView/ListCustomerInEactivity?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch overview`, error);
      throw error;
    }
  }

  async getDetailCustomer(params: any = {}) {
    let path = `/api/ManagementView/GetCustomer?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch overview`, error);
      throw error;
    }
  }

  async getDetailH2H(params: any = {}) {
    let path = `/api/ManagementView/GetCustomerDetailH2H?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch overview`, error);
      throw error;
    }
  }

  async getViewSaleManagerByCustomer(params: any = {}) {
    let path = `/api/ManagementView/ViewSaleManagerByCustomer?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch customer`, error);
      throw error;
    }
  }

  async getViewSaleManagerBySurveyHistory(params: any = {}) {
    let path = `/api/ManagementView/Survey/History?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error fetch history`, error);
      throw error;
    }
    /*
    return [
      {
        surveyDate: '2025-05-23T14:21:14.463',
        surveyName: 'สำรวจยอดซื้อและสต๊อก (Fixed Form) AUTOMATE POM Activity1',
      },
    ];
    */
  }
}
